import React from 'react'
import styled from 'react-emotion'
import { connect } from 'react-redux'
import { color } from 'stylist'

const VerticalDividerContainer = styled.span`
  display: inline-block;
  margin-left: 8px;
  margin-right: 8px;
  color: ${color('pewter')};
`

const VerticalDivider = () => (
  <VerticalDividerContainer>|</VerticalDividerContainer>
)

const BackLinkContainer = styled.a`
  display: inline-block;
  font-size: 12px;
  font-weight: 900;
  color: ${color('blue')};
  letter-spacing: 0.8px;
  text-transform: uppercase;
`

const TitleContainer = styled.span`
  display: inline-block;
  font-size: 12px;
  font-weight: 900;
  color: ${color('silver')};
  letter-spacing: 0.8px;
  text-transform: uppercase;
`

const Nav = ({ backText, backUrl }) => (
  <div>
    <BackLinkContainer href={backUrl}>
      <span className="ion-arrow-left-c" /> {backText}
    </BackLinkContainer>
    <VerticalDivider />
    <TitleContainer>content review</TitleContainer>
  </div>
)

const mapStateToProps = state => {
  return {
    backText: state.surveyMeta.backConfig.text,
    backUrl: state.surveyMeta.backConfig.url
  }
}

export default connect(mapStateToProps)(Nav)



// WEBPACK FOOTER //
// ./src/components/Editor/Header/Nav.js